
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: "Validate bank accounts and reduce returns through an end-to-end pay-with-your-bank solution with Adyen"
};
export const partnerProps = {
  partner: 'Adyen',
  clientLibrary: 'adyen',
  subtitle: metadata.description,
  registrationUrl: 'https://www.adyen.com/signup',
  apiUrl: 'https://docs.adyen.com/',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid and Adyen have partnered to allow businesses to verify bank accounts and reduce returns through an end-to-end ACH solution.
Plaid enables consumers and businesses to instantly authenticate their bank account including account and routing number as well as the current account balance. The account details are delivered directly to Adyen via a secure tokenized integration. Adyen processes the ACH transaction (supports both ACH credits and ACH debits), integrating the payment or payout into your existing settlement and reconciliation process with Adyen.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AdyenInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
